import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

// Default: grow with content; Document is the scrollport.
// fillRemaining: interactive docs fill under tabs; iframe scrolls inside.
export const StyledRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isModal' && prop !== 'fillRemaining',
})(({ theme, isModal, fillRemaining }) => ({
  flex: fillRemaining ? '1 1 auto' : '0 0 auto',
  minHeight: isModal ? 'calc(100vh - 128px)' : fillRemaining ? 0 : undefined,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  overflow: fillRemaining ? 'hidden' : undefined,

  [theme.breakpoints.up('xl')]: {
    width: isModal ? undefined : '100%',
  },

  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },

  '& .MuiTab-labelIcon': {
    minHeight: 50,
  },

  '@media print': {
    height: 'auto',
    minHeight: 0,
    overflow: 'visible',
    display: 'block',
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.getContrastText(theme.palette.primary.dark),

  '& .MuiTab-root': {
    color: 'inherit',
    opacity: 0.75,
    '&.Mui-selected': {
      opacity: 1,
    },
  },

  '& .MuiTab-wrapper': {
    flexDirection: 'row',
  },
  '& .MuiTab-wrapper > *:first-child': {
    marginBottom: 0,
    marginRight: theme.spacing(1),
  },
}));

export const StyledContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fillRemaining',
})(({ theme, fillRemaining }) => ({
  flex: fillRemaining ? '1 1 auto' : '0 0 auto',
  minHeight: fillRemaining ? 0 : undefined,
  width: '100%',
  maxWidth: fillRemaining ? 'none' : theme.breakpoints.values['lg'],
  margin: fillRemaining ? 0 : '0 auto',
  textAlign: 'left',
  marginBottom: fillRemaining ? 0 : theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  overflow: fillRemaining ? 'hidden' : 'visible',
  '@media print': {
    maxWidth: 'none',
    margin: 0,
    height: 'auto',
    overflow: 'visible',
  },
}));
